import { useUiComponentsInternationalContext } from '@repo/static-translations';

/* This function converts the socialMedia object from Sanity into an array of objects

  Example input:
  {
    "facebookBool": true,
    "facebookUrl": "https://www.facebook.com/petsafebrand",
  }

  Example output:
  [{"label": "Facebook", "value": "https://www.facebook.com/petsafebrand"}]
*/

const useConvertToObjectArray = data => {
  const { tt } = useUiComponentsInternationalContext();

  return Object.entries(data)
    .map(([key, value]) => {
      if (key.endsWith('Bool') && value) {
        const label = key.replace('Bool', '');

        if (label === 'twitter') {
          return {
            label: tt(s => s.utilsDeptLabels.formerlyTwitter),
            value: data.twitterUrl,
          };
        }

        const valueKey = `${label.toLowerCase()}Url`;
        return { label, value: data[valueKey] };
      }
      return null;
    })
    .filter(Boolean);
};

export default useConvertToObjectArray;
